module.exports = __webpack_public_path__ + "static/media/1_A1_17.74732506.png";